import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Mail, Lock } from "lucide-react"; // Importăm iconițele
import { supabase } from "../supabaseClient";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    setLoading(false);
    if (error) {
      setError("Email sau parolă incorectă. Te rugăm să încerci din nou."); // Mesaj de eroare mai prietenos
    } else {
      window.location.href = "/dashboard"; 
    }
  };

  return (
    <>
      {/* Mic bloc de stiluri pentru hover și focus, menținând codul curat */}
      <style>
        {`
          .premium-input:focus {
            outline: none !important;
            box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.3) !important;
            border-color: #fbbf24 !important;
          }
          .premium-link {
            color: #94a3b8;
            transition: color 0.2s ease;
          }
          .premium-link:hover {
            color: #fbbf24;
          }
        `}
      </style>

      <div
        className="d-flex justify-content-center align-items-center vh-100"
        style={{ backgroundColor: "#0b1120" }} // Dark Navy de fundal
      >
        <div
          style={{
            maxWidth: "420px",
            width: "100%",
            borderRadius: "24px",
            backgroundColor: "#131c31", // Culoarea cardului, puțin mai deschisă decât fundalul
            padding: "40px 30px",
            border: "1px solid rgba(255, 255, 255, 0.05)",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
          }}
          className="mx-3"
        >
          {/* Logo */}
          <div className="d-flex justify-content-center mb-4">
            <img
              src="/logo.webp"
              alt="PRDP Logo"
              style={{ width: "80px", height: "80px", objectFit: "contain" }}
            />
          </div>

          {/* Titluri */}
          <div className="text-center mb-5">
            <h2 className="fw-bold mb-2" style={{ color: "#f8fafc", fontSize: "1.75rem" }}>
              Autentificare Membri
            </h2>
            <p style={{ color: "#94a3b8", fontSize: "0.95rem" }}>
              Introdu datele pentru a accesa platforma.
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            {/* Input Email */}
            <div className="mb-4">
              <label 
                className="form-label d-block" 
                style={{ color: "#cbd5e1", fontSize: "0.75rem", fontWeight: "600", letterSpacing: "1px", textTransform: "uppercase" }}
              >
                Email
              </label>
              <div className="position-relative">
                <div 
                  className="position-absolute d-flex align-items-center justify-content-center" 
                  style={{ top: "0", bottom: "0", left: "15px", color: "#94a3b8" }}
                >
                  <Mail size={18} />
                </div>
                <input
                  type="email"
                  className="form-control premium-input"
                  placeholder="suport@prdp.ro"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    backgroundColor: "#f1f5f9",
                    border: "1px solid transparent",
                    borderRadius: "12px",
                    padding: "14px 15px 14px 45px", // Spațiu la stânga pentru iconiță
                    fontSize: "1rem",
                    color: "#0f172a",
                    fontWeight: "500"
                  }}
                  required
                />
              </div>
            </div>

            {/* Input Parolă */}
            <div className="mb-4">
              <label 
                className="form-label d-block" 
                style={{ color: "#cbd5e1", fontSize: "0.75rem", fontWeight: "600", letterSpacing: "1px", textTransform: "uppercase" }}
              >
                Parolă
              </label>
              <div className="position-relative">
                <div 
                  className="position-absolute d-flex align-items-center justify-content-center" 
                  style={{ top: "0", bottom: "0", left: "15px", color: "#94a3b8" }}
                >
                  <Lock size={18} />
                </div>
                <input
                  type="password"
                  className="form-control premium-input"
                  placeholder="••••••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{
                    backgroundColor: "#f1f5f9",
                    border: "1px solid transparent",
                    borderRadius: "12px",
                    padding: "14px 15px 14px 45px",
                    fontSize: "1rem",
                    color: "#0f172a",
                    fontWeight: "500"
                  }}
                  required
                />
              </div>
            </div>

            {/* Mesaj de eroare */}
            {error && (
              <div 
                className="mb-4 p-3 rounded" 
                style={{ backgroundColor: "rgba(239, 68, 68, 0.1)", borderLeft: "4px solid #ef4444" }}
              >
                <p className="text-danger m-0" style={{ fontSize: "0.85rem", fontWeight: "500" }}>
                  {error}
                </p>
              </div>
            )}

            {/* Buton Submit */}
            <button
              type="submit"
              disabled={loading}
              className="btn w-100 fw-bold border-0 mt-2"
              style={{
                backgroundColor: "#fbbf24", // Galben premium
                color: "#0f172a", // Text închis pentru contrast maxim
                borderRadius: "12px",
                padding: "14px",
                fontSize: "1rem",
                transition: "all 0.2s ease",
                opacity: loading ? 0.7 : 1,
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f59e0b"}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fbbf24"}
            >
              {loading ? "Se încarcă..." : "Conectează-te"}
            </button>
          </form>

          {/* Linkuri Footer */}
          <div className="mt-5 text-center">
            <p className="mb-2" style={{ fontSize: "0.85rem", color: "#64748b" }}>
              Nu ai cont?{" "}
              <a href="https://prdp.ro/implica-te" className="text-decoration-none fw-semibold premium-link">
                Înregistrează-te aici
              </a>
            </p>
            <p className="m-0" style={{ fontSize: "0.85rem", color: "#64748b" }}>
              Ai uitat parola?{" "}
              <a href="/reset-password" className="text-decoration-none fw-semibold premium-link">
                Resetează parola
              </a>
            </p>
          </div>
          
          <div className="text-center mt-5">
            <span style={{ fontSize: "0.7rem", color: "#475569", letterSpacing: "1px" }}>
              © 2026 PARTIDUL ROMÂNIA DREAPTĂ ȘI PROSPERĂ
            </span>
          </div>

        </div>
      </div>
    </>
  );
}
